<template>
    <div class="user-admin">
        <b-row>
        <b-table  class="table-responsive" hover striped :items="filteredList" :fields="fields">
            <template v-slot:cell(actions)="data">
                <b-button  size="sm" v-b-modal.modalPassword variant="light" @click="loadUser(data.item)" class="mr-2 mt-2" >
                    <i class="fa fa-key"></i>
                </b-button>
            </template>
        </b-table>
         </b-row>
          <b-modal id="modalPassword"
            ref="modal"
            title-tag = "h6"
            title="Change Password"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="passwordChange"
            >
             <b-row v-show="mode === 'save'">
                <b-col md="6" sm="12">
                    <b-form-group 
                        label="Password:" 
                        label-for="user-password">
                        <b-form-input 
                            id="user-password" 
                            type="password"
                            size="sm"
                            v-model="user.password"
                            placeholder="Password..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group 
                            label="Confirm the Password:" 
                            label-for="user-confirm-password">
                        <b-form-input 
                            id="user-confirm-password" 
                            type="password"
                            size="sm"
                            v-model="user.confirmPassword" 
                            placeholder="Confirm the Password..." />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-modal>  
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'

export default {
    name: 'ChangePassword',
    data: function() {
        return {
            mode: 'insert',
            search: '',
            user: {},
            users: [],
            companys:[],
            setores: [],
            headerBgVariant: 'primary',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            fields: [
                { key: 'name', label: 'Name', sortable: true },
                { key: 'email', label: 'E-mail', sortable: false },
                { key: 'actions', label: 'Ações' , variant: 'secondary' }
            
            ]
        }
    },computed: {
        filteredList() {
        return this.users.filter(user => {
        return user.name.toLowerCase().includes(this.search.toLowerCase())
            })
        },
        compan(){
            return this.$store.state.compan
        },
        userStore(){
                    return this.$store.state.user
           },
    },
    methods: {
        loadUsers() {
            const url = `${baseApiUrl}/usersbychange/${this.compan.id}/?context_id=${this.userStore.id}`
            axios.get(url).then(res => {
                this.users = res.data
            })
        },
        reset() {
            this.user = {}
            this.mode = 'insert'
            this.loadUsers()
        },
        save() {
            const method = this.user.id ? 'put' : 'post'
            const id = this.user.id ? `/${this.user.id}` : ''
            axios[method](`${baseApiUrl}/users${id}`, this.user)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        passwordChange() {
            const method = this.user.id ? 'put' : 'post'
            const id = this.user.id ? `/${this.user.id}` : ''
            axios[method](`${baseApiUrl}/passwordChange${id}`, this.user)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },

        loadUser(user, mode = 'save') {
            this.mode = mode
            this.user = { ...user }
            this.$refs.searchFocus.focus();
        },
    },
    mounted() {
        this.loadUsers()
    }
}
</script>

<style>

    .user-admin select{
        font-size: 0.75rem;
        background-color: #FFF;
    }
    .user-admin input{
        font-size: 0.75rem;
    }
    .user-admin button{
        font-size: 0.75rem;
    }
    .user-admin table{
        font-size: 0.75rem;
           color: #FFF;
    }

      .user-admin label{
        font-size: 0.75rem;
        color: #FFF;
    }

    #modalPassword{
         font-size: 0.8rem;
    }

    #modalPassword label{
         font-size: 0.8rem;
    }

    #modalPassword button{
         font-size: 0.8rem;
    }

    #modalPassword input{
        font-size: 0.8rem;
    }


</style>
